import dayjs from "dayjs";

/**
 * Retorna un arreglo formateado
 * @param {*} date
 * @param {*} type S: Semana, M: Mes, A: Año
 * @returns
 */
export default function formatDateType(date = [], type = "S") {
  const arrDate = [];
  const newArr = [];
  // Guardamos las fechas en un nuevo arreglo
  arrDate.push(date);

  switch (type) {
    case "S":
      arrDate[0].forEach((x) => {
        newArr.push(dayjs(x).format("DD-MM-YY HH:mm"));
      });

      return newArr;

    case "M":
      arrDate[0].forEach((x) => {
        newArr.push(dayjs(x).format("DD-MM-YY"));
      });

      return newArr;

    case "A":
      arrDate[0].forEach((x) => {
        newArr.push(dayjs(x).format("MM-YY"));
      });
      return newArr;

    default:
      return [];
  }
}
